import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { IanTranslateService } from 'core/services/ian-core-singleton.service';
import { ChatType } from './models/chat-interface';

@Component({
  selector: 'ai-chat-wrapper',
  template: `
    <div fxLayout="column" fxFlex class="ai-chat-wrapper" [class.in-panel]="isInPanel()" [class.in-page]="!isInPanel()">
      <!-- Header - only for panel mode -->
      <mat-list class="date" cdkFocusRegionStart *ngIf="isInPanel()">
        <mat-icon (click)="closeQuickPanel()" class="closeQuickPanel">close</mat-icon>
        <mat-icon (click)="onResetConversation()" class="resetChat" [matTooltip]="'AI_CHAT.INPUT.RESET_TOOLTIP' | pTranslate"
          >restart_alt</mat-icon
        >
        <h3 matSubheader class="notification-title">
          <ai-icon [size]="28" svgStyle="padding-right: 4px; vertical-align: bottom;"></ai-icon>
          {{ getHeaderTitle() }}
        </h3>
      </mat-list>

      <div class="chat-container" fxFlex>
        <!-- Databricks chat original -->
        <databricks-chat-content
          *ngIf="chatType === ChatType.DATABRICKS"
          [isInPanelContext]="isInPanel()"
          [showChatTypeSelector]="showChatTypeSelector"
          [selectedChatType]="chatType"
          [availableChatTypes]="availableChatTypes"
          (onResetRequest)="onResetConversation()"
          (chatTypeChange)="onChatTypeChange($event)"
        >
        </databricks-chat-content>

        <!-- Streaming chat con SSE -->
        <streaming-chat-content
          *ngIf="chatType === ChatType.STREAMING"
          [isInPanelContext]="isInPanel()"
          [showChatTypeSelector]="showChatTypeSelector"
          [selectedChatType]="chatType"
          [availableChatTypes]="availableChatTypes"
          (onResetRequest)="onResetConversation()"
          (chatTypeChange)="onChatTypeChange($event)"
        >
        </streaming-chat-content>
      </div>
    </div>
  `,
  styleUrls: ['./ai-chat-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AiChatWrapperComponent implements OnInit, OnDestroy {
  @Input() chatType: ChatType = ChatType.DATABRICKS;
  @Input() isInPanelContext = false; // Input para detectar si estamos en contexto de panel
  @Input() showChatTypeSelector = false; // Mostrar selector en el input
  @Input() availableChatTypes: { value: ChatType; label: string; description: string }[] = [];

  @Output() chatTypeChange = new EventEmitter<ChatType>(); // Evento para cambio de tipo

  // Expose ChatType enum for template
  ChatType = ChatType;

  constructor(private _fuseSidebarService: FuseSidebarService, private translate: IanTranslateService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  isInPanel(): boolean {
    return this.isInPanelContext;
  }

  getHeaderTitle(): string {
    switch (this.chatType) {
      case ChatType.DATABRICKS:
        return this.translate.instant('AI_CHAT.HEADERS.DATABRICKS_TITLE');
      case ChatType.STREAMING:
        return this.translate.instant('AI_CHAT.HEADERS.STREAMING_TITLE');
      default:
        return this.translate.instant('AI_CHAT.HEADERS.DEFAULT_TITLE');
    }
  }

  onResetConversation(): void {
    // El reset será manejado por el componente hijo específico
    // Este método será llamado por el chat content component
  }

  onChatTypeChange(newType: ChatType): void {
    this.chatTypeChange.emit(newType);
  }

  closeQuickPanel(): void {
    // Solo cerrar el panel si estamos en contexto de panel
    if (this.isInPanel()) {
      setTimeout(() => {
        this._fuseSidebarService.getSidebar('quickPanelAi') && this._fuseSidebarService.getSidebar('quickPanelAi').close();
      });
    }
  }
}
